var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        id: "Ebene_3",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M93.674,41.33c0-13.41-10.871-24.281-24.281-24.281s-24.28,10.872-24.28,24.282\n\tc0,7.978,3.849,15.057,9.79,19.484C48.06,63.799,42.3,68.801,38.375,75.069",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M70.45,97.839c-25.951,0-46.989-21.038-46.989-46.989S44.499,3.861,70.45,3.861\n\tc22.707,0,41.653,16.107,46.034,37.519",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "Ebene_2_1_" } }, [
        _c("g", { attrs: { id: "Pressemitteilung" } }, [
          _c("path", {
            staticClass: "st1",
            attrs: {
              d: "M75.625,51.239h46.725c2.85,0,5.175,2.325,5.175,5.175v27.113c0,2.85-2.325,5.175-5.175,5.175H75.625\n          c-2.85,0.037-5.175-2.288-5.175-5.138v-27.15C70.45,53.564,72.775,51.239,75.625,51.239z",
            },
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st1",
            attrs: { x1: "77.35", y1: "62.813", x2: "120.625", y2: "62.813" },
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st1",
            attrs: { x1: "77.35", y1: "69.97", x2: "114.85", y2: "69.97" },
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st1",
            attrs: { x1: "77.65", y1: "77.127", x2: "91.188", y2: "77.127" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }